import { useQuery } from '@tanstack/react-query';
import { getMenu, getRestaurant } from '../services/api';

/**
 * Hook to fetch menu data
 * Uses shorter staleTime (1 min) to keep menu availability fresh.
 * refetchOnMount defaults to true — only refetches if data is stale (>1 min),
 * avoiding unnecessary API calls when switching between views within the same session.
 */
export function useMenu(restaurantId: string | null) {
  return useQuery({
    queryKey: ['menu', restaurantId],
    queryFn: () => getMenu(restaurantId!),
    enabled: !!restaurantId,
    staleTime: 1000 * 60 * 1, // 1 minute - shorter to catch stock changes faster
  });
}

/**
 * Hook to fetch restaurant info
 * Uses moderate staleTime (2 min) to balance freshness with performance.
 * refetchOnMount defaults to true — only refetches if data is stale (>2 min),
 * avoiding unnecessary API calls when switching between views within the same session.
 */
export function useRestaurant(restaurantId: string | null) {
  return useQuery({
    queryKey: ['restaurant', restaurantId],
    queryFn: () => getRestaurant(restaurantId!),
    enabled: !!restaurantId,
    staleTime: 1000 * 60 * 2, // 2 minutes - catch branding/config changes reasonably fast
  });
}

